<template>
  <a-form-model class="form" :model="form" ref="editForm" :rules="rules">
    <a-form-model-item label="轮播列表">
      <div class="item-list">
        <a-form-model class="item-form" v-for="(img, i) in items" :key="i">
          <a-form-model-item label="链接">
            <a-input v-model="img.link" placeholder="图片跳转链接"></a-input>
          </a-form-model-item>
          <a-form-model-item label="图片">
            <cl-upload direct v-model="img.url"></cl-upload>
          </a-form-model-item>
          <a-icon class="icon-close" type="close" @click="remove(i)" />
        </a-form-model>
      </div>
      <div class="add-item" @click="addItem">
        <div class="add-icon"></div>
        <div class="add-txt">添加轮播项</div>
      </div>
    </a-form-model-item>
    <a-form-model-item label="自动播放">
      <a-switch v-model="form.auto"></a-switch>
    </a-form-model-item>
    <a-form-model-item label="播放间隔（秒）" v-show="form.auto">
      <a-input v-model="form.delay"></a-input>
    </a-form-model-item>
    <!-- <a-form-model-item label="宽度" prop="width">
      <a-input
        type="number"
        v-model="form.width"
        placeholder="最大宽度375"
      ></a-input>
    </a-form-model-item> -->
    <a-form-model-item label="高度" prop="height">
      <a-input type="number" v-model="form.height"></a-input>
    </a-form-model-item>
    <a-form-model-item label="圆角">
      <a-input type="number" v-model="form.borderRadius"></a-input>
    </a-form-model-item>
    <a-form-model-item label="内层间距" v-if="form.padding">
      <a-space>
        <a-input
          type="number"
          class="inline-input"
          placeholder="上"
          v-model="form.padding.top"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="下"
          v-model="form.padding.bottom"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="左"
          v-model="form.padding.left"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="右"
          v-model="form.padding.right"
        ></a-input>
      </a-space>
    </a-form-model-item>
    <a-form-model-item label="外层间距" v-if="form.margin">
      <a-space>
        <a-input
          type="number"
          class="inline-input"
          placeholder="上"
          v-model="form.margin.top"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="下"
          v-model="form.margin.bottom"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="左"
          v-model="form.margin.left"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="右"
          v-model="form.margin.right"
        ></a-input>
      </a-space>
    </a-form-model-item>
    <a-form-model-item label="背景色">
      <colorPicker
        class="color-picker top shadow"
        v-model="form.backgroundColor"
      ></colorPicker>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import clUpload from "../cl-upload";
import { clone } from "../../common/js/tool";

export default {
  name: "carousel-edit",
  components: {
    clUpload,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      form: {},
      rules: {
        // width: [{ required: true, message: "请输入宽度", trigger: "blur" }],
        height: [{ required: true, message: "请输入高度", trigger: "blur" }],
      },
      items: [],
    };
  },
  watch: {
    form: {
      handler() {
        this.update();
      },
      deep: true,
    },
    items: {
      handler() {
        this.update();
      },
      deep: true,
    },
    value() {
      this.setValue();
    },
  },
  created() {
    this.setValue();
  },
  methods: {
    setValue() {
      if (this.value) {
        let temp = clone(this.value);
        this.items = temp.imgList;
        delete temp.imgList;
        this.form = temp;
      }
    },
    addItem() {
      this.items.push({ url: null, link: null });
    },
    remove(i) {
      this.items.splice(i, 1);
    },
    update() {
      let temp = clone(this.form);
      temp.imgList = clone(this.items);
      this.$emit("change", temp);
    },
    validate() {
      let msg = null;
      this.$refs.editForm.validate((flag) => {
        if (!flag) {
          msg = "请正确填写表单项";
        }
      });
      let items = this.items;
      for (let i = 0, l = items.length; i < l; i++) {
        let item = items[i];
        if (!item.url) {
          msg = `请上传第${i + 1}项轮播图图片`;
          break;
        }
      }
      return msg;
    },
  },
};
</script>

<style scoped lang="less">
.color-picker::v-deep {
  .colorBtn {
    width: 20px;
    height: 20px;
  }
}
</style>
